
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { initialState } from '@/components/Form/ProductsFilter/productsFilterSlice';
import { getUseProductCacheKey } from '@/lib/hooks/fetchers/useProducts';
import { Category } from '@/lib/types/bevmaq.types';
import {
  getCategories,
  getCountries,
  getIndustryCategories,
  getManufacturers,
  getProducts,
} from '@/lib/utilities/repository';
import { GetStaticPaths, GetStaticProps } from 'next/types';
import React from 'react';
import ProductsIndex from '../..';

function ProductCategory({ fallback }: { fallback: any }) {
  return <ProductsIndex fallback={fallback} />;
}

export default ProductCategory;

 const _getStaticProps: GetStaticProps = async ({ params, locale }) => {
  if (!params?.category_slug) {
    throw new Error('no category slug');
  }
  const category_slug = params.category_slug.toString();
  const productsRes = await getProducts({
    categories: category_slug,
    locale: locale,
  });
  const categories = await getCategories(locale);
  const industry_categories = await getIndustryCategories(locale);
  const countries = await getCountries(locale);
  const manufacturers = await getManufacturers(locale);
  return {
    props: {
      fallback: {
        [getUseProductCacheKey(initialState, locale, category_slug)]:
          productsRes,
        [`/api/industry-categories/${locale}`]: industry_categories,
        [`/api/categories/${locale}`]: categories,
        [`/api/countries/${locale}`]: countries,
        [`/api/manufacturers/${locale}`]: manufacturers,
      },
    },
    revalidate: 120,
  };
};

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  // Call an external API endpoint to get all products
  // so we have all slugs and can pre generate the pages
  const paths: { params: any; locale: string }[] = [];
  if (locales) {
    for (const locale of locales) {
      const categories = await getCategories(locale);
      categories.forEach((categorie: Category) => {
        const path = {
          params: {
            category_slug: categorie.slug,
          },
          locale,
        };
        paths.push(path);
      });
    }
  }

  return {
    paths,
    fallback: false, // if you add a new category (API) you will need to rebuild the frontend
  };
};


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/buy/category/[category_slug]/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  